'use client';

import { ReactNode, useEffect, useState } from 'react';

type HydrationErrorBoundaryProps = {
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * A component that prevents hydration errors by not rendering children until client-side hydration is complete.
 * This is useful for components that rely on browser-specific APIs or have dynamic values that
 * cause hydration mismatches between server and client rendering.
 */
export function HydrationErrorBoundary({
  children,
  fallback = null,
}: HydrationErrorBoundaryProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}

export default HydrationErrorBoundary;
